<div class="create-ayuda-page">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">CREAR AYUDA</h1>
                <p class="page-subtitle text-muted">
                    Registre un manual, documento (PDF/Word) o enlace a video de YouTube
                </p>
            </div>
        </div>
    </div>
    <div class="page-content">
        <mat-card class="form-card">
            <mat-card-content>
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="form-section">
                        <h6 class="section-title d-flex align-items-center mb-3">
                            <i class="ri-information-line me-2 text-primary"></i>
                            Información de la ayuda
                        </h6>

                        <div class="form-grid basic-grid">
                            <mat-form-field appearance="outline" class="form-field full-width">
                                <mat-label>Título</mat-label>
                                <input matInput formControlName="titulo" maxlength="200" inputmode="text" />
                                <mat-error *ngIf="form.get('titulo')?.hasError('required')">Requerido</mat-error>
                                <mat-error *ngIf="form.get('titulo')?.hasError('maxlength')">Máximo 200 caracteres</mat-error>
                            </mat-form-field>

                            <div class="form-field full-width">
                                <label class="form-label">Tipo</label>
                                <mat-radio-group formControlName="tipo" aria-label="Tipo" class="radio-group">
                                    <mat-radio-button value="documento">Documento (PDF o Word)</mat-radio-button>
                                    <mat-radio-button value="video">Video de YouTube</mat-radio-button>
                                </mat-radio-group>
                            </div>

                            <ng-container *ngIf="form.get('tipo')?.value === 'documento'">
                                <div class="form-field full-width">
                                    <label class="file-upload-label">
                                        <span class="label-text">Archivo (PDF o Word)</span>
                                        <input
                                            type="file"
                                            #fileInput
                                            accept=".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            (change)="onFileChange($event)"
                                            class="file-input" />
                                        <div class="file-info" *ngIf="selectedFile">
                                            <i class="ri-file-line me-2"></i>
                                            <span>{{ selectedFile.name }}</span>
                                        </div>
                                        <div class="file-hint" *ngIf="!selectedFile">Seleccione un archivo PDF o Word</div>
                                    </label>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="form.get('tipo')?.value === 'video'">
                                <mat-form-field appearance="outline" class="form-field full-width">
                                    <mat-label>URL de YouTube</mat-label>
                                    <input matInput formControlName="url" placeholder="https://www.youtube.com/watch?v=..." inputmode="url" />
                                    <mat-error *ngIf="form.get('url')?.hasError('required')">Requerido para tipo video</mat-error>
                                </mat-form-field>
                            </ng-container>

                            <mat-form-field appearance="outline" class="form-field full-width">
                                <mat-label>Descripción (opcional)</mat-label>
                                <textarea matInput formControlName="descripcion" rows="3" maxlength="2000" inputmode="text"></textarea>
                            </mat-form-field>

                            <div class="form-field checkbox-field full-width">
                                <mat-checkbox formControlName="activo" color="primary">
                                    Ayuda activa
                                </mat-checkbox>
                            </div>
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Orden</mat-label>
                                <input matInput type="number" formControlName="orden" min="0" inputmode="numeric" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-actions">
                        <button type="button" mat-button (click)="onCancel()" [disabled]="isLoading">
                            <i class="ri-arrow-left-line me-2"></i>
                            Cancelar
                        </button>
                        <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid || isLoading">
                            <span *ngIf="!isLoading">
                                <i class="ri-add-line me-2"></i>
                                Crear Ayuda
                            </span>
                            <span *ngIf="isLoading">
                                <i class="ri-loader-4-line animate-spin me-2"></i>
                                Creando...
                            </span>
                        </button>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>
